import React, { useState, useRef, useEffect } from 'react';
import axiosInstance from './../axiosInstance.js';
import Datetime from 'react-datetime';
import moment from 'moment';
import "moment/locale/ru"; // Import the Russian locale
import "react-datetime/css/react-datetime.css";
import "./Logbook.css"; // Import custom CSS for styling

moment.locale("ru");

const Logbook = ({ art, initialDateTimes, language }) => {
  const [dates, setDates] = useState(initialDateTimes || []);
  const [currentValue, setCurrentValue] = useState(""); // State for the current input value
  const [currentValueNote, setCurrentValueNote] = useState(""); // State for the current note input value
  const [finished, setFinished] = useState(art.category === 1);
  const [cursorPosition, setCursorPosition] = useState(0); // State to track cursor position
  const inputElement = useRef(null); // Ref for the input element
  const refs = useRef({}); // Create a refs object to store refs for each dateTime

  console.log("Initial dateTimes:", initialDateTimes);
  console.log("Current dates state:", dates);

  useEffect(() => {
    if (inputElement.current) {
      inputElement.current.setSelectionRange(cursorPosition, cursorPosition); // Restore cursor position
    }
  }, [currentValue, cursorPosition]); // Trigger on currentValue or cursorPosition change

  const onInput = () => {
    if (inputElement.current) {
      setCursorPosition(inputElement.current.selectionStart); // Update cursor position
    }
  };

  const isDuplicateDate = (newDate) => {
    return dates.some(
      (date) =>
        moment(newDate).format("YYYY-MM-DD HH:mm") ===
        moment(date).format("YYYY-MM-DD HH:mm")
    );
  };

  const showPopup = (message) => {
    alert(message); // Use native browser alert
  };

  const handleAddDate = () => {
    const parsedDate = moment(currentValue, ["DD.MM.YYYY HH:mm", "D MMM YYYY HH:mm"], true);
    if (!parsedDate.isValid()) {
      showPopup(language === "ru" ? "Выберите дату" : "Select date");
      return;
    }
    const newDate = parsedDate.toISOString();
    if (isDuplicateDate(newDate)) {
      showPopup(language === "ru" ? "Вы уже добавили такую же дату" : "You already added the same date");
      return;
    }
    const payload = { date: newDate, note: currentValueNote };
    if (art.category === 1 || art.category === 2 || art.category === 3) {
      payload.finished = finished;
    }
    axiosInstance
      .post(`/art/logbook/${art.id}/add`, payload)
      .then((response) => {
        setDates([response.data, ...dates]); // Add the returned object to the dates state
        setCurrentValue(""); // Clear input after adding
        setCurrentValueNote(""); // Clear note input after adding
        setFinished(art.category === 1);
      })
      .catch((error) => {
        console.error("Failed to add date:", error);
      });
  };

  useEffect(() => {
    setFinished(art.category === 1);
  }, [art.category]);

  // const handleRemoveDate = (logbookItemId) => {
  //   axiosInstance
  //     .delete(`/art/logbook/${logbookItemId}/remove`)
  //     .then(() => {
  //       const updatedDates = dates.filter((date) => date.id !== logbookItemId);
  //       setDates(updatedDates);
  //     })
  //     .catch((error) => {
  //       console.error("Failed to remove date:", error);
  //     });
  // };

  const handleQuickAddDate = (offsetHours) => {
    let newDate;
    if (offsetHours === "zero") {
      newDate = new Date(0); // Zero date
    } else {
      newDate = new Date();
      newDate.setHours(newDate.getHours() - offsetHours);
    }
    setCurrentValue(moment(newDate).format("DD.MM.YYYY HH:mm")); // Keep currentValue as a formatted date
  };

  // const handleUpdateNote = (logbookItemId, updatedNote) => {
  //   axiosInstance
  //     .post(`/art/logbook/${logbookItemId}/update`, { note: updatedNote })
  //     .then(() => {
  //       const updatedDates = dates.map((date) =>
  //         date.id === logbookItemId ? { ...date, note: updatedNote } : date
  //       );
  //       setDates(updatedDates);
  //     })
  //     .catch((error) => {
  //       console.error("Failed to update note:", error);
  //     });
  // };

  return (
    <div class="mt-1">
      <div class="flex justify-center items-center space-x-4 mt-1">
        <span
          class="underline decoration-dashed cursor-pointer"
          onClick={() => handleQuickAddDate(0)}
        >
          {language === "ru" ? "Только что" : "Just now"}
        </span>
        <span
          class="underline decoration-dashed cursor-pointer"
          onClick={() => handleQuickAddDate(1)}
        >
          {language === "ru" ? "Час назад" : "An hour ago"}
        </span>
        <span
          class="underline decoration-dashed cursor-pointer"
          onClick={() => handleQuickAddDate(4)}
        >
          {language === "ru" ? "4 часа назад" : "4 hours ago"}
        </span>
        <span
          class="underline decoration-dashed cursor-pointer"
          onClick={() => handleQuickAddDate(24)}
        >
          {language === "ru" ? "Вчера" : "Yesterday"}
        </span>
        <span
          class="underline decoration-dashed cursor-pointer"
          onClick={() => handleQuickAddDate("zero")}
        >
          {language === "ru" ? "Давно" : "Long time ago"}
        </span>
      </div>
      <div class="flex justify-center items-center mt-1">
        {new Date(currentValue).getTime() === 0 ? ( // Check if currentValue is zero
          <span class="text-gray-900 text-2xl">
            {language === "ru" ? "Давно" : "Long time ago"}
          </span>
        ) : (
          <Datetime
            locale={language}
            value={currentValue} // Keep currentValue as a date
            onChange={(input) => {
              if (typeof input === "string") {
                const parsedDate = moment(input, "DD.MM.YYYY", true);
                if (parsedDate.isValid()) {
                  setCurrentValue(parsedDate.format("DD.MM.YYYY 00:00")); // Append 00:00 time for valid date
                } else {
                  setCurrentValue(input); // Keep input as-is for invalid date
                }
              } else if (moment.isMoment(input) && input.isValid()) {
                setCurrentValue(input.format("DD.MM.YYYY HH:mm")); // Update with valid date
              } else {
                setCurrentValue(""); // Clear input if invalid
              }
            }}
            inputProps={{
              onInput, // Track cursor position during input
              ref: inputElement, // Attach ref to the input element
            }}
            dateFormat="DD.MM.YYYY" // Update format to DD.MM.YYYY
            timeFormat="HH:mm"
            className="dark-datetime-picker" // Apply custom class for dark style
          />
        )}
      </div>
      <div class="flex justify-center items-center mt-1">
        <button
          class="bg-gray-500 text-white px-4 rounded hover:bg-gray-700"
          onClick={handleAddDate}
        >
          {language === "ru" ? "Добавить дату" : "Add date"}
        </button>
      </div>
      <div class="flex justify-center items-center mt-2">
        <label class="flex items-center gap-2 text-sm text-gray-300">
          <input
            type="checkbox"
            checked={finished}
            onChange={(event) => setFinished(event.target.checked)}
            className="accent-blue-500"
          />
          {(() => {
            if (language === "ru") {
              if (art.category === 1) return "Вы досмотрели фильм?";
              if (art.category === 2) return "Вы прошли игру?";
              if (art.category === 3) return "Вы дочитали книгу?";
              return "Вы закончили?";
            }
            if (art.category === 1) return "Did you finish the movie?";
            if (art.category === 2) return "Did you finish the game?";
            if (art.category === 3) return "Did you finish the book?";
            return "Did you finish it?";
          })()}
        </label>
      </div>
      <div class="mt-7">
        <div class="flex justify-center font-semibold mb-1">
          {language === "ru" ? "Добавленные даты:" : "Added dates:"}
        </div>
        {dates.length === 0 ? (
          <div class="flex justify-center text-gray-500">
            {language === "ru" ? "Пока не добавлено ни одной даты" : "No dates added yet"}
          </div>
        ) : (
          <ul className="space-y-2">
            {dates.map((dateTime) => {
              if (!refs.current[dateTime.id]) {
                refs.current[dateTime.id] = React.createRef(); // Initialize ref for each dateTime
              }
              return (
                <li key={dateTime.id} className="flex items-center justify-between p-2 rounded shadow-md">
                  <div className="flex flex-col items-center w-full">
                    <span className="text-gray-900 text-lg text-center">
                      {new Date(dateTime.logTime).getTime() === 0
                        ? (language === "ru" ? "Давно" : "Long time ago")
                        : moment(dateTime.logTime).format("DD MMM YYYY HH:mm")}
                    </span>
                    <input
                      type="text"
                      ref={refs.current[dateTime.id]} // Use the ref from the refs object
                      className="text-gray-600 text-sm bg-gray-100 p-2 rounded focus:outline-none w-3/4 text-center"
                      value={dateTime.note || ""}
                      maxLength={100}
                      placeholder={language === "ru" ? "Добавить заметку" : "Add a note"}
                      onChange={(e) => {
                        const updatedNote = e.target.value;
                        const updatedDates = dates.map((date) =>
                          date.id === dateTime.id ? { ...date, note: updatedNote } : date
                        );
                        setDates(updatedDates); // Update note locally
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevent form submission
                          axiosInstance
                            .post(`/art/logbook/${dateTime.id}/update`, { note: dateTime.note || "" })
                            .then(() => {
                              const updatedDates = dates.map((date) =>
                                date.id === dateTime.id ? { ...date, note: dateTime.note } : date
                              );
                              setDates(updatedDates);
                              refs.current[dateTime.id].current.blur(); // Lose focus after saving
                            })
                            .catch((error) => {
                              console.error("Failed to update note:", error);
                            });
                        }
                      }}
                    />
                  </div>
                  <button
                    className="text-red-500 hover:text-red-700 ml-4 self-center"
                    onClick={() => {
                      const formattedDate = new Date(dateTime.logTime).getTime() === 0
                        ? (language === "ru" ? "Давно" : "Long time ago")
                        : moment(dateTime.logTime).format("DD MMM YYYY HH:mm");
                      const confirmMessage = language === "ru"
                        ? `Вы уверены, что хотите удалить эту дату: ${formattedDate}?`
                        : `Are you sure you want to delete this date: ${formattedDate}?`;
                      if (window.confirm(confirmMessage)) {
                        axiosInstance
                          .delete(`/art/logbook/${dateTime.id}/remove`)
                          .then(() => {
                            const updatedDates = dates.filter((date) => date.id !== dateTime.id);
                            setDates(updatedDates);
                          })
                          .catch((error) => {
                            console.error("Failed to remove date:", error);
                          });
                      }
                    }}
                  >
                    &times;
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Logbook;
